import hfdLogo from "../assets/images/epost_small_logo.png"

let hfd = {}

hfd.orderType = 24
hfd.accountType = 18

hfd.renderLogo = () => {
  return (
    <img className="logo-service-icon hfd" src={hfdLogo} alt={"logo hfd"} />
  )
}

hfd.formatWaybill = (value) => {
  let v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "")

  const matches = v.match(/\[^0-9]{8}$/g)
  let match = (matches && matches[0]) || ""

  let parts = []
  let i = 0
  let len
  for (i = 0, len = match.length; i < len; i += i === 0 || i === 3 ? 2 : 4) {
    parts.push(match.substring(i, i + (i === 0 || i === 3 ? 2 : 4)))
  }

  if (parts.length) {
    return parts.join(" ")
  } else {
    return value
  }
}
hfd.barcodeMinLength = 6
hfd.validatePackageBarcode = (barcode) => {
  if (!barcode || barcode.length < 6 || barcode.length > 50) {
    return false
  }
  return true
  //const barcodeRegex = /^([0-9A-Za-z]{3-50}$)/
  //const res = barcodeRegex.test(barcode)
  //return res
}

export const hfdProvider = hfd
